import React from 'react';
import { Box } from '@chakra-ui/react';
import CodeEditor from '../../../../CodeEditorComponent/components/CodeEditor';

const CodeEditorModal = ({
  onClose,
  onChangeInputValue,
  onLanguageChange,
  onSubmit,
  initialValue,
  question_remarks,
  interviewId,
  backgroundImage,
  onTimerChange,
  autoSaveCode,
  question,
  isMinimized = false
}) => {
  return (
    <div style={{
      ...styles.codeEditorContainer(backgroundImage),
      display: isMinimized ? 'none' : 'flex'
    }}>
      <div style={styles.codeEditorWrapper}>
        <CodeEditor
          onClose={onClose}
          onChangeInputValue={onChangeInputValue}
          onLanguageChange={onLanguageChange}
          onSubmit={onSubmit}
          initialValue={initialValue}
          question_remarks={question_remarks}
          interviewId={interviewId}
          onTimerChange={onTimerChange}
          autoSaveCode={autoSaveCode}
        />
      </div>
    </div>
  );
};

const styles = {
  codeEditorContainer: (backgroundImage) => ({
    background: `url(${backgroundImage})`,
    backdropFilter: 'blur(12px)',
    position: 'absolute',
    zIndex: 999,
    height: '100vh',
    width: '100vw',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }),
  codeEditorWrapper: {
    position: 'absolute',
    zIndex: 99999999,
    backgroundColor: '#1A202C',
    width: '100vw',
    height: '100vh'
  }
};

export default CodeEditorModal;